<template>
  <div
    v-if="!pdp.product.isOutofSale"
    v-show="visible"
    :class="{ 'ua-pdt-stc': true, 'is-mobile': isMobile }"
  >
    <div class="ua-pdt-stc-inner">
      <gt-tabs
        v-model="actived"
        :class="{ 'is-less': menus.length < 3 }"
        :stretch="false"
        @tab-click="toggle"
      >
        <gt-tab-pane v-for="menu in menus" :key="menu.name" :label="menu.title" :name="menu.name">
          <span>{{ menu.label }}</span>
        </gt-tab-pane>
      </gt-tabs>

      <div
        v-if="!isMobile && !pdp.product.isHasPerHotActivity && pdp.product.isStock"
        class="ua-pdt-stc__actions"
      >
        <!-- 会员优先购，显示会员色按钮，加入会员 -->
        <gt-button
          v-if="
            pdp.product.spuCampaign &&
            pdp.product.spuCampaign.activityType === '6002' &&
            !pdp.product.spuCampaign.canBuy &&
            (isGuest || !isLogin)
          "
          class="black-to-red"
          style="flex: 1"
          size="medium"
          type="default"
          @click="pdp.joinMember"
        >
          加入会员解锁优先购买权益
        </gt-button>
        <template v-else>
          <gt-button
            v-if="pdp.product.isAdd2Shopcart"
            style="width: 150px"
            size="medium"
            type="default"
            :loading="pdp.product.pickupData.loading"
            :disabled="!pdp.product.isStock || pdp.product.dontAllowBuyNow"
            @click="addToCart"
          >
            加入购物袋
          </gt-button>
          <gt-button
            v-if="pdp.product.productType !== '4'"
            style="width: 150px; margin-left: 0px"
            size="medium"
            type="primary"
            :disabled="!pdp.product.isStock || pdp.product.dontAllowBuyNow"
            :loading="pdp.product.pickupData.checkoutLoading"
            @click="toCheckout"
          >
            立即购买
          </gt-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import lo from 'lodash';
import { PDP } from '../lib/mixins';

export default {
  name: 'PdtShortcut',
  mixins: [PDP],
  provide() {
    return {
      shortcut: this
    };
  },
  data() {
    return {
      visible: false,
      menus: [],
      actived: '',
      intersectionObserver: null,
      intersectionRatioMap: {}
    };
  },
  computed: {
    offset() {
      return 960;
    }
  },
  watch: {
    menus: {
      handler(list) {
        this.initObserver(list);
      }
    }
  },
  mounted() {
    // watch the scroll change
    this.$nextTick(() => this.$watch('$store.state.pageScrollY', v => this.scrollHdl(v)));
  },
  methods: {
    sync() {
      const nodes = document.querySelectorAll('.pdp-anchor');
      const menus =
        nodes && nodes.length
          ? lo.reduce(
              nodes,
              (ctr, el) => {
                const title =
                  (this.isMobile && el.getAttribute('short-title')) || el.getAttribute('title');
                const name = el.getAttribute('name');

                name && title && ctr.push({ title, name });

                return ctr;
              },
              []
            )
          : [];

      this.menus = menus;

      menus.length && (this.actived = menus?.[0].name);
    },
    scrollToView() {
      if (!this.pdp.activedSizeAttr) {
        window.scrollTo({ top: 0 });
      }
    },
    initObserver(list) {
      this.$nextTick(() => {
        const attrName = 'data-pdp-anchor-id';
        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }
        // console.log(
        //   '%c [kanyixia  ]-145',
        //   'font-size:13px; background:#b2ae43; color:#f6f287;',
        //   this.intersectionRatioMap
        // );

        const intersectionObserver = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              const name = entry.target.getAttribute(attrName);
              // console.log('initObserver', name, entry.intersectionRatio);
              this.intersectionRatioMap[name] = entry.intersectionRatio;
              const targetName = Object.keys(this.intersectionRatioMap).reduce((prev, curr) => {
                return this.intersectionRatioMap[curr] >= this.intersectionRatioMap[prev]
                  ? curr
                  : prev;
              }, list?.[0].name);
              if (this.intersectionRatioMap[targetName] > 0) {
                this.actived = targetName;
              }
              // if (entry.intersectionRatio > 0) {
              //   this.actived = entry.target.getAttribute(attrName);
              // }
            });
          },
          {
            // root: document.getElementsByClassName('.ua-pdp')[0],
            // rootMargin: '10% 0px 20% 0px'
          }
        );
        list.forEach(item => {
          const el = document.getElementById(item.name);
          const target = el.parentElement;
          target.setAttribute(attrName, item.name);
          intersectionObserver.observe(target);
        });
      });
    },
    addToCart() {
      this.scrollToView();
      this.pdp.addToShopCart();
    },
    toCheckout() {
      this.scrollToView();
      this.pdp.checkout();
    },
    getScopeTop(el) {
      return el ? el.getBoundingClientRect().top : 0;
    },
    getPositionTop(el) {
      const offset = 280;
      const top = this.$store.state.pageScrollY + this.getScopeTop(el) - offset;
      return top >= 0 ? top : 0;
    },
    toggle(item) {
      const ref = document.getElementById(item.name);

      if (ref) {
        const top = this.getPositionTop(ref);

        window.scrollTo({ top });
      }
    },
    scrollHdl(pageScrollY) {
      this.visible = !!(pageScrollY >= this.offset);

      // if (!this.visible) return;
      // console.log('scrollHdl', pageScrollY, this.menus);
      // const target = lo
      //   .chain(this.menus)
      //   .map(({ name }) => {
      //     const el = document.getElementById(name);
      //     let top;

      //     if (el) {
      //       top = this.getScopeTop(el);
      //     }

      //     return {
      //       top,
      //       absTop: Math.abs(top),
      //       el,
      //       name
      //     };
      //   })
      //   .filter(item => item.top !== undefined)
      //   .reduce((prev, curr) => {
      //     return !prev || (prev.top <= 0 && curr.top > 0) || prev.absTop >= curr.absTop
      //       ? curr
      //       : prev;
      //   }, null)
      //   .value();

      // target && target.name && (this.actived = target.name);
    }
  }
};
</script>

<style lang="scss" layout="pc" description="网页端样式">
.ua-pdt-stc {
  position: sticky;
  top: 100px;
  left: 0px;
  right: 0px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
  background: var(--main-color-ua-white, #fff);
  z-index: 100;

  &-inner {
    max-width: 1440px;
    width: 85%;
    margin: 0 auto;
    padding: 18px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--main-color-ua-white, #fff);
    position: relative;
    z-index: 2000;

    .el-tabs__header {
      margin-bottom: 0px;
    }
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
  }
}

.gt-layout.gt-layout-without-ad {
  .ua-pdt-stc.is-mobile {
    top: 54px;
  }
}
</style>

<style lang="scss" layput="mobile" description="移动端样式">
.page-layout_mobile .ua-pdt-stc {
  top: 94px;
  &-inner {
    width: 100%;
    margin: 0 auto;
    padding: 13px 0px;
    display: block;

    .el-tabs.gt-tabs {
      width: 100%;
      padding: 0px;

      .el-tabs__nav {
        display: flex;
        justify-content: center;
      }

      .el-tabs__item {
        margin-left: 24px !important;
        margin-right: 24px !important;
        padding: 0px !important;
        text-align: center;
        position: relative;

        &.is-active::after {
          content: ' ';
          height: 4px;
          left: 0px;
          bottom: 0px;
          right: 0px;
          position: absolute;
          display: block;
          background-color: var(--coupon-status-tab-active-bar-color);
        }
      }

      // .el-tabs__item:nth-of-type(2) {
      //   text-align: left !important;
      // }

      // .el-tabs__item:last-child {
      //   text-align: right !important;
      // }

      .el-tabs__active-bar {
        display: none;
      }
    }
  }
}
</style>
